import {
    DEALERVIEWDSRLIST_FAILED,
    DEALERVIEWDSRLIST_SUCCESS,
    RESET_DEALERVIEWDSRLIST,
    LOADING_DEALERVIEWDSRLIST,
    NETWORK_ERROR_DEALERVIEWDSRLIST

} from '../types/index';

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERVIEWDSRLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERVIEWDSRLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERVIEWDSRLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERVIEWDSRLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERVIEWDSRLIST:
            return (state = initialState);
        default:
            return state;
    }
};